import { Box, Typography } from "@mui/material";
import BrowserIcon from "assets/icons/browser.svg";
import CatalogIcon from "assets/icons/catalog.svg";
import ShareIcon from "assets/icons/share.svg";
import { myBusinessListStyles } from "styles/BusinessListDirectory/myBusinessList.styles";

interface ShareContainerProps {
  link: string;
}

const ShareContainer = ({ link }: ShareContainerProps) => {
  const handleShare = () => {
    if (navigator.share) {
      navigator
        .share({
          title: "Share Link",
          url: link,
        })
        .then(() => console.log("Link shared"))
        .catch((err) => console.error("Error sharing link", err));
    } else {
      alert("Web Share API is not supported on this browser.");
    }
  };

  const handleOpenLink = () => {
    window.open(link, "_blank");
  };

  const handleCopyToClipboard = () => {
    navigator.clipboard
      .writeText(link)
      .then(() => {
        alert("Booking Link Copied to Clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
        alert("Failed to copy the link.");
      });
  };

  return (
    <Box sx={myBusinessListStyles.shareContainer}>
      {link && (
        <Box sx={myBusinessListStyles.iconRow}>
          {/* Share Button */}
          <Box sx={myBusinessListStyles.iconWrapper} onClick={handleShare}>
            <Box>
              <img src={ShareIcon} width={24} height={24} alt="share-icon" />
            </Box>
            <Typography sx={myBusinessListStyles.iconText}>Share</Typography>
          </Box>

          {/* Open Link Button */}
          <Box sx={myBusinessListStyles.iconWrapper} onClick={handleOpenLink}>
            <Box>
              <img
                src={BrowserIcon}
                width={24}
                height={24}
                alt="browser-icon"
              />
            </Box>
            <Typography sx={myBusinessListStyles.iconText}>Open</Typography>
          </Box>

          {/* Copy Button */}
          <Box
            sx={myBusinessListStyles.iconWrapper}
            onClick={handleCopyToClipboard}
          >
            <Box>
              <img
                src={CatalogIcon}
                width={24}
                height={24}
                alt="catalog-icon"
              />
            </Box>
            <Typography sx={myBusinessListStyles.iconText}>Copy</Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ShareContainer;
